import { Box, Dialog, IconButton, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Close from "../../assets/svg/Close";
import CustomButton from "../../components/common/CustomButton";
import Loader from "../../components/common/Loader";
import PlanTable from "../../components/PlansTable";
import TextFieldBox from "../../components/common/TextField";
import { API_ROUTES } from "../../utils/Api/ApiConfig";
import { apiGet, apiPatch, apiPost } from "../../utils/Api/ApiCalls";
import { colors } from "../../utils/colors/Index";

const AddPlans = () => {
  const [formData, setFormData] = useState({
    planname: "",
    duration: null,
    price: null,
    discount: null,
    upi: null,
    QRcode: null,
  });
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [planData, setPlanData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [fileName, setFileName] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1]; // remove "data:image/...;base64,"
        setFormData((prev) => ({ ...prev, QRcode: base64String }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.planname) newErrors.planname = "Plan Name is required";

    if (!formData.duration) newErrors.duration = "Duration is required";
    if (!formData.price) newErrors.price = "price is required";
    if (!formData.upi) newErrors.upi = "upi is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleClose = () => {
    // setOpen(false);
    setFormData({
      planname: "",
      duration: null,
      price: null,
      discount: null,
    });
  };
  const fetctPlanDetails = async () => {
    setIsLoading(true);
    try {
      const response = await apiGet(API_ROUTES.GET_PLANS);
      if (response.status === 200) {
        setPlanData(response?.data?.plans);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetctPlanDetails();
  }, []);
  const handleSubmit = async () => {
    console.log(formData);

    if (!validateForm()) return;
    setLoader(true);
    if (edit) {
      try {
        const body = {
          planId: formData?._id,
          name: formData?.planname,
          actualprice: formData?.price,
          duration: formData?.duration,
          action: "update",
          discount: formData?.discount,
          upi: formData?.upi,
          package: formData.duration === "30" ? "1 month pack" : "premium pack",
          label: "label",
          createdDate: new Date(),
          QRcode: formData?.QRcode,
        };
        console.log(body);

        const response = await apiPatch(API_ROUTES.UPDATE_PLANS, body);
        if (response.status === 200) {
          console.log("Form submitted successfully:", response.data);
          setFormData({
            planname: "",
            duration: "",
            price: "",
            discount: "",
            upi: "",
            QRcode: null,
          });
          setFileName(null);
          fetctPlanDetails();
          setEdit(false);
        }
      } catch (error) {
        console.log("Error submitting form:", error);
      } finally {
        setLoader(false);
        setEdit(false);
      }
    } else {
      try {
        const body = {
          action: "insert",
          label: "label",
          package: formData.duration === "30" ? "1 month pack" : "premium pack",
          name: formData?.planname,
          actualprice: formData?.price,
          duration: formData?.duration,
          discount: formData?.discount,
          createdDate: new Date(),
          QRcode: formData?.QRcode,
          upi: formData?.upi,
        };

        const response = await apiPost(API_ROUTES.POST_PLANS, body);
        if (response.status === 200) {
          console.log("Form submitted successfully:", response.data);
          setFormData({
            planname: "",
            duration: "",
            price: "",
            discount: "",
            upi: "",
            QRcode: null,
          });
          setFileName(null);
          fetctPlanDetails();
        }
      } catch (error) {
        console.log("Error submitting form:", error);
      } finally {
        setLoader(false);
      }
    }
  };
  const handleDelete = async (_id) => {
    setIsLoading(true);
    const body = {
      planId: _id,
      action: "delete",
    };
    try {
      const response = await apiPatch(API_ROUTES.UPDATE_PLANS, body);
      if (response.status === 200) {
        console.log(response.data);
        fetctPlanDetails();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        padding: "1rem",
        rowGap: "0.5rem",
        position: "relative",
      }}
    >
      {/* <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: "0",
                right: "0",
                padding: "0.5rem",
              }}
            >
              <Close />
            </IconButton> */}
      <Typography variant="h5" color={colors.text.primary} sx={{ mb: "1rem" }}>
        Plans
      </Typography>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "row",
          columnGap: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "40%",
            flexDirection: "column",
            rowGap: "1rem",
          }}
        >
          <Typography
            sx={{ fontSize: 16, color: colors.text.primary, fontWeight: 600 }}
          >
            Add Plan
          </Typography>
          <Box
            sx={{
              display: "flex",
              width: "90%",
              flexDirection: "column",
              rowGap: "0.5rem",
            }}
          >
            <LabelTypography>Enter Plan Name</LabelTypography>
            <TextFieldBox
              placeholder=""
              name="planname"
              value={formData.planname}
              onChange={handleChange}
              error={!!errors.planname}
              helperText={errors.planname}
            />

            <LabelTypography>Enter Duration</LabelTypography>
            <TextFieldBox
              placeholder=""
              name="duration"
              type="number"
              value={formData.duration}
              onChange={handleChange}
              error={!!errors.duration}
              helperText={errors.duration}
            />
            <LabelTypography>UPI ID</LabelTypography>

            <TextFieldBox
              placeholder=""
              name="upi"
              value={formData.upi}
              onChange={handleChange}
              error={!!errors.upi}
              helperText={errors.upi}
            />
            <LabelTypography>Enter Price</LabelTypography>
            <TextFieldContainer>
              <Box
                sx={{ display: "flex", width: "100%", alignItems: "center" }}
              >
                <RupeeContainer>
                  <Typography>₹</Typography>
                </RupeeContainer>
                <TextFieldBox
                  placeholder=""
                  name="price"
                  type="number"
                  value={formData.price}
                  onChange={handleChange}
                />
              </Box>
              {errors.price && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ marginTop: "0.5rem", ml: "3.5rem" }}
                >
                  {errors.price}
                </Typography>
              )}
            </TextFieldContainer>
            <LabelTypography>Discount</LabelTypography>
            <TextFieldContainer>
              <Box
                sx={{ display: "flex", width: "100%", alignItems: "center" }}
              >
                <RupeeContainer>
                  <Typography>%</Typography>
                </RupeeContainer>
                <TextFieldBox
                  placeholder=""
                  name="discount"
                  type="number"
                  value={formData.discount}
                  onChange={handleChange}
                />
              </Box>
            </TextFieldContainer>

            <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
              Upload QR Code
            </Typography>
            <FileUploadBox>
              {console.log(fileName, "filename")}
              {fileName ? (
                <Typography sx={{ color: "#333", fontWeight: 500 }}>
                  {fileName}
                </Typography>
              ) : (
                <Typography sx={{ color: "#555", fontWeight: 500 }}>
                  ⬆ Upload QR
                </Typography>
              )}
              <HiddenFileInput
                type="file"
                accept="image/*"
                onChange={handleFileChange}
              />
            </FileUploadBox>

            <Box display={"flex"} columnGap={"1rem"} width={"50%"}>
              <CustomButton
                title={edit ? "Update Plan" : "Add Plan"}
                variant="contained"
                loading={loader}
                fullWidth
                handleClick={handleSubmit}
                sx={{
                  color: "white",
                  textTransform: "capitalize",
                  borderRadius: "8px",
                  marginTop: "1rem",
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "60%",
            flexDirection: "column",
            rowGap: "1rem",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : (
            <PlanTable
              planData={planData}
              setFormData={setFormData}
              setEdit={setEdit}
              handleDelete={handleDelete}
              setFileName={setFileName}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AddPlans;

const FileUploadBox = styled(Box)(({ theme }) => ({
  border: "1px solid #DCDCDC",
  borderRadius: 8,
  backgroundColor: "#F1F1F1",
  padding: "0.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "relative",
  transition: "border-color 0.3s",
}));

const HiddenFileInput = styled("input")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  opacity: 0,
  cursor: "pointer",
});
const LabelTypography = styled(Typography)(({ theme }) => ({
  color: colors.text.primary,
  fontSize: "14px",
}));
const TextFieldContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
}));
const RupeeContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "0.5rem 1rem",
  backgroundColor: "#FFF9E6",
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
}));

// {
//   "_id": {
//     "$oid": "673ebb1e5e2b997cd19f5440"
//   },
//   "name": "Journey Plan",
//   "package": "3 Months Plan",
//   "duration": 90,
//   "label": "Membership",
//   "price": 13200,
//   "discount": "20%",
//   "actualprice": 16500
// }
